import Search from "../../components/select/Search";
import ServerTable from "../../components/atoms/tables/serverTable";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Axios from "../../AxiosConfig";
import { useStore } from "../../store";
import Loader from "../../components/atoms/loader";
import swal from 'sweetalert';
const Attendance = ({ }) => {
    const navigate = useNavigate();
    const { layoutStore } = useStore();
    const [employee, setEmployee] = useState(null);
    const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split("T")[0]);
    const [filters, setFilters] = useState({});
    const [refresh, setRefresh] = useState(0);
    const [loading, setLoading] = useState(false);
    const [reportUrl, setReportUrl] = useState(null);
    const currentDate = new Date().toISOString().split("T")[0]
    const maxDate = new Date(new Date().setDate(new Date().getDate())).toISOString().split("T")[0]
    // Covert date to time string not to be confused with local time
    const converToString = (date) => {
        let d = new Date(date);
        return d.toTimeString().split(" ")[0];
    }
    const columns = [
        {
            name: "Name",
            cell: (row) => (
                <a
                    href={`/employees/${row.user_uuid}`}
                    target="_blank"
                    className="text-blue-600 hover:text-blue-900 hover:underline"
                >
                    {row.name} <ArrowTopRightOnSquareIcon className="inline w-4 h-4" />
                </a>

            )
        },
        {
            name: "Designation",
            selector: "designation",
        },
        {
            name: "Department",
            selector: "department",
        },
        {
            name: "Date",
            selector: "date",
            sortable: true,
            cell: (row) => (
                <span>{new Date(row.date).toLocaleDateString()}</span>
            )
        },
        {
            name: "Worked Hours",
            selector: "timeWorked",
            sortable: true,
            cell: (row) => (
                <span>{row.timeWorked && Math.round(((row.timeWorked / 60) / 60) * 100) / 100} hours</span>
            )
        },
        {
            name: "Check In",
            cell: (row) => (
                <span>
                    {(row.punches.length > 0 && row.punches[0].punchIn) && new Date(row.punches[0].punchIn).toLocaleTimeString()}
                </span>
            )
        },
        {
            name: "Check Out",
            cell: (row) => (
                <span>
                    {(row.punches.length > 0 && row.punches[row.punches.length - 1].punchOut) ? new Date(row.punches[row.punches.length - 1].punchOut).toLocaleTimeString() : "Still Checked In"}
                </span>
            )
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="flex">
                    <button
                        type="button"
                        onClick={() => {
                            swal({
                                text: "Are you sure you want to delete this attendance?",
                                icon: "warning",
                                buttons: true,
                                dangerMode: true,
                            })
                            .then((willDelete) => {
                                if (willDelete) {
                                    Axios.post("/working-days/attendance/delete", { id: row._id }).then((res) => {
                                        if (res.data.success) {
                                            layoutStore.showToaster("Attendance deleted successfully", "success");
                                            setRefresh(new Date().getTime());
                                        }
                                        else {
                                            layoutStore.showToaster("Error deleting attendance", "error");
                                        }
                                    });
                                }
                            });
                            // let confirm = window.confirm("Are you sure you want to delete this attendance?");
                            // if (confirm) {
                            //     Axios.post("/working-days/attendance/delete", { id: row._id }).then((res) => {
                            //         if (res.data.success) {
                            //             layoutStore.showToaster("Attendance deleted successfully", "success");
                            //             setRefresh(new Date().getTime());
                            //         }
                            //         else {
                            //             layoutStore.showToaster("Error deleting attendance", "error");
                            //         }
                            //     });
                            // }

                        }}
                        className="ml-2 inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs leading-4 font-medium rounded text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                        Delete
                    </button>
                </div>
            )
        }
    ]
    useEffect(() => {
        let _filters = {};
        if (employee) {
            _filters.employee = employee.uuid;
        }
        if (startDate) {
            _filters.startDate = startDate;
        }
        if (endDate) {
            _filters.endDate = endDate;
        }
        setFilters(_filters);
    }, [employee, startDate, endDate]);

    const downloadReport = () => {
        setLoading(true);
        Axios.post("/reports/attendance", { filters }).then((res) => {
            if (res.data.success) {
                setReportUrl(res.data.url);
                window.open(res.data.url, "_blank");
            }
            else {
                layoutStore.showToaster(res.data.error, "error")
            }
            setLoading(false);
        });

    };
    return (
        <div>
            {loading && <Loader />}
            {
                reportUrl &&
                <div className="rounded-md bg-blue-50 p-4 mb-4">
                    <div className="flex">
                        <div className="ml-3 flex-1 md:flex md:justify-between">
                            <p className="text-sm text-blue-700">
                                If the download didn't start automatically, download the report by clicking the link 👉.
                            </p>
                            <p className="mt-3 text-sm md:mt-0 md:ml-6">
                                <a href={reportUrl}
                                    target="_blank"
                                    className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600">
                                    Download Report
                                    <span aria-hidden="true"> &rarr;</span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            }
            <div className="mt-2 rounded-md flex heightAuto">
                <div className="grow mr-px">
                    <label htmlFor="startDate" >
                        Start Date
                    </label>
                    <input
                        type="date"
                        name="startDate"
                        id="startDate"
                        value={startDate || ""}
                        onChange={(e) => {
                            setStartDate(e.target.value)

                            if (e.target.value > maxDate){
                                setStartDate(maxDate)
                                setEndDate(maxDate)
                            } else{
                                setStartDate(e.target.value)
                            }
                            if (new Date(e.target.value) > new Date(endDate) || !endDate) {
                                setEndDate(e.target.value)
                            }
                        }}
                        max={maxDate}
                        min={new Date(new Date().setFullYear(new Date().getFullYear() - 10)).toISOString().split("T")[0]}
                        className="block w-full rounded-l-md border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                        />
                </div>
                <div className="grow mx-px">
                    <label htmlFor="endDate" >
                        End Date
                    </label>
                    <input
                        type="date"
                        name="endDate"
                        id="endDate"
                        value={endDate}
                        onChange={(e) => {
                            // if (new Date(e.target.value) < new Date(startDate) || !startDate) {
                            //     setStartDate(e.target.value)
                            // }

                            if (e.target.value > maxDate) {
                                setEndDate(maxDate)
                            } else{
                                setEndDate(e.target.value)
                            }
                            // setEndDate(e.target.value)
                        }}
                        // max today + 1 day
                        max={maxDate}
                        className="block w-full border-gray-300 hover:border-blue-500 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                        min={startDate}
                    />
                </div>
                <div>

                    <button
                        type="button"
                        onClick={() => {
                            window.location.reload();
                        }}
                        disabled={!filters.employee && (startDate == currentDate) && (endDate == currentDate)}
                        className="mt-6 items-center border border-transparent bg-blue-600 px-4 py-2 mx-px text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Reset Filters
                    </button>
                </div>
                <div>

                    <button
                        type="button"
                        onClick={downloadReport}
                        className="mt-6 items-center border border-transparent bg-blue-600 px-4 py-2 mx-px text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Export Data
                    </button>
                </div>
                <div>

                    <button
                        type="button"
                        onClick={() => navigate("/attendance/new")}
                        className="mt-6 items-center rounded-r border border-transparent bg-blue-600 px-4 py-2 ml-px text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                        Create Attendance
                    </button>
                </div>
            </div>
            <div className="mt-1 flex rounded-md shadow-sm">

                <div className="grow">
                    <label htmlFor="employee" >
                        Employee
                    </label>
                    <div className="border border-0.5 border-gray-300 rounded-md hover:border-blue-500">
                        <Search
                            apiURL="/employee/search"
                            setParent={setEmployee}
                        />
                    </div>
                </div>
            </div>
            <div className='mt-4'>
                <ServerTable
                    key={JSON.stringify(filters) + refresh.toString()}
                    apiURL={'/working-days/attendance'}
                    columns={columns}
                    filters={filters}
                />
            </div>
        </div>
    )
}
export default Attendance;